/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineSystemService() {
        let systemService = {};
        systemService.getProvinces = function (){
            return axios.get("/api/SystemService/GetProvinces");
        };
        systemService.getAllDepots = function (request){
            return axios.post("/api/SystemService/GetAllDepots", request);
        };
        systemService.getAllDepotPumpsByDepotId = function (depotId){
            return axios.get("/api/SystemService/GetAllDepotPumpsByDepotId?depotId=" + depotId);
        };
        systemService.getTerminals = function (orderTypeId, zoneId) {
            if(orderTypeId === undefined){
                orderTypeId = null;
            }
            if(zoneId === undefined){
                zoneId = null;
            }
            return axios.get("/api/SystemService/GetTerminals?orderTypeId=" + orderTypeId + "&zoneId=" + zoneId);
        };
        systemService.getZones = function (fieldsToFilterBy, request, getFromApi, activeOnly) {
            let localStorageKey = localStorageCacheHelper.localStorageKey.zonesKey;
            if(!activeOnly){
                localStorageKey = localStorageCacheHelper.localStorageKey.zonesInactiveKey;
            }
            //return axios.post("/api/SystemService/GetZones", request);
            return localStorageCacheHelper.getDataPost("/api/SystemService/GetZones", fieldsToFilterBy, request, localStorageKey, getFromApi);
        };
        return systemService;
    }
    //define globally if it doesn't already exist
    if (typeof (systemService) === "undefined") {
        window.systemService = defineSystemService();
    } else {
        console.log("systemService already defined.");
    }
})(window);